import type { AllApiError } from '@frontend/api-types';
import type { SerializedError } from '@reduxjs/toolkit';

export const handleErrorResponse = <TError extends MaybeUndefined<AllApiError | SerializedError>>(
  error: TError,
  handler: (_: Exclude<TError, SerializedError>) => void,
) => handler(error as Exclude<TError, SerializedError>);
